/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
        Module No. 17, SBC, Thejaswini Building
        Phase 1, Technopark, Thiruvananthapuram - 695581, 
        Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";
import { StringifyOptions } from "querystring";

// Fetches MLT Bio burden task list
const getMLTBioBurdenListTask = async (page: number, size: number, sort: any, order: any, fromDate?: string, toDate?: string, keyword?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/mlt_bioburden/list_tasks?page=${page}&size=${size}&sort=${sort}&order=${order}&from_date=${fromDate}&to_date=${toDate}&keyword=${keyword}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches MLT Bio burden task details
const getMLTBioBurdenTaskDetails = async (testId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/mlt_bioburden/details?task_id=${testId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// pre treatment list
const getPreTreatmentList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/mlt_master/list_pretreatment`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// filter type list
const getFilterTypeList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/mlt_master/list_filter_type`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// pore size list
const getPoreSizeList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/mlt_master/list_pore_size`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// membrane diameter list
const getMembraneDiameterList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/mlt_master/list_membrane_diameter`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// dilution factor list
const getDilutionFactorList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/mlt_master/list_dilution_factor`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// initiate MLT Bio burden test
const initiateMLTBioBurdenTest = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/mlt_initiate/initiate_mlt_bioburden_test`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

export const MLTBioBurdenServices = {
  getMLTBioBurdenListTask,
  getMLTBioBurdenTaskDetails,
  getPreTreatmentList,
  getFilterTypeList,
  getPoreSizeList,
  getMembraneDiameterList,
  getDilutionFactorList,
  initiateMLTBioBurdenTest
}